import { ColorProps } from '@chakra-ui/react';
import { ChoiceStatus } from '@payflip/utils';
import { Tag, TagProps } from '../../../atoms';

type Props = {
  status: ChoiceStatus;
  isImported: boolean;
} & TagProps;

const BackgroundColor: { [key in ChoiceStatus]: ColorProps['color'] } = {
  APPROVED: 'palette_success.5',
  PENDING: 'palette_warning.5',
  CANCELED: 'palette_alert.5',
  SELECTED: 'palette_gray.5',
  CONFIRMED: 'palette_success.5',
  SUBMITTED: 'palette_warning.5'
};

export function ChoiceStatusTag({
  status,
  children,
  isImported
}: Props): JSX.Element {
  const color = isImported ? 'palette_gray.0' : BackgroundColor[status];
  return (
    <Tag
      h="36px"
      py="space_unit.x1"
      px="space_unit.x2"
      size="lg"
      borderRadius="full"
      backgroundColor={color}
      color="palette_gray.100"
      w="fit-content"
      textStyle="bodyLarge"
    >
      {children}
    </Tag>
  );
}
